import moment from 'moment';

/**
 * Compute EDC by AOG
 * @param aog - age of gestation, usually days
 * @param usDate - ultrasound date
 */
export function computeEdcByAog(aog: number, usDate: Date): string {
  const days = 280 - aog;
  return moment(usDate).add(days, 'days').format('MMM DD, YYYY')
}

/**
 * Compute EDC by LMP Date
 * @param date - LMP Date
 */
export function computeEdcByDate(date: Date): string {
  return moment(date).add(9, 'months').add(7, 'days').format('MMM DD, YYYY')
}

/**
 * Compute AOG by LMP Date
 * @param date - LMP Date
 */
export function computeAogByDate(date: Date): string {
  let item = moment(new Date()).diff(moment(date))
  let newItem = moment.duration(item);

  let week = Math.floor(newItem.asDays() / 7);
  let days = Math.floor(newItem.asDays() - (week * 7));

  if (week == 0 && days == 0) {
      return "---"
  }

  if (week == 0) {
      let desc = days == 1 ? 'day' : 'days';
      return days + " " + desc;
  }

  if (week != 0 && days == 0) {
      let desc = week == 1 ? 'week' : 'weeks';
      return week + " " + desc;
  }

  return week + " w / " + days + " d"
}

/** UTILITIES */
export function getDefaultAogWeeks(): string[] {
  let items: string[] = [];
  for (let i = 0; i <= 45; i += 5) {
      let desc = i <= 1 ? "week" : "weeks"
      items.push(i + " " + desc);
  }
  return items;
}

export function getDefaultAogDays(): string[] {
  let items: string[] = [];
  for (let i = 0; i <= 6; i++) {
      let desc = i <= 1 ? "day" : "days"
      items.push(i + " " + desc);
  }
  return items;
}